import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ProductService {
    private apiUrl = `${environment.apiUrl}/sellerProducts`;

    constructor(private http: HttpClient) { }



    get(title?: string): Observable<any> {
        let url = `${this.apiUrl}?title=${title}`;

        return this.http.get(url, { observe: 'response' });

    }
}
